import { render, staticRenderFns } from "./EduCourseDetailView.vue?vue&type=template&id=42e6a57a"
import script from "./EduCourseDetailView.vue?vue&type=script&lang=js"
export * from "./EduCourseDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports